
import { ShieldCheck, LayoutGrid } from "lucide-react";
import { MegaMenuItem } from "./MegaMenuItem";
import { Link } from "react-router-dom";

interface SpecializationsMenuProps {
  isOpen: boolean;
}

export const SpecializationsMenu = ({ isOpen }: SpecializationsMenuProps) => {
  return (
    <div className={`${isOpen ? 'block' : 'hidden'} absolute top-full left-1/2 transform -translate-x-1/2 mt-2 w-[600px] bg-white rounded-xl shadow-xl border border-gray-100 p-6 grid grid-cols-1 gap-6`}>
      <Link to="/specializations/microsoft-365-security">
        <MegaMenuItem
          icon={ShieldCheck}
          title="Microsoft 365 Specialized Security"
          description="Transform your Microsoft 365 environment from a vulnerability into your strongest defense. We specialize in securing your digital workspace without compromising productivity."
        />
      </Link>
      <Link to="/specializations/microsoft-365-engineering">
        <MegaMenuItem
          icon={LayoutGrid}
          title="Microsoft 365 Engineering + Architecture"
          description="Optimize your Microsoft 365 environment with expert engineering and architecture services. We design and implement solutions that maximize productivity and security."
        />
      </Link>
    </div>
  );
};
